// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__2d63o","refCountersContainer":"styles_refCountersContainer__366WO","textContainer":"styles_textContainer__1keS4","overviewTitle":"styles_overviewTitle__33IV1"};